import React from 'react'
import { Nav, Navbar, Container } from 'react-bootstrap'

const Navigation = () => {
    return (
        <>
            <Navbar fixed="top" collapseOnSelect expand="lg" bg="dark" variant="dark">
                <Container>
                    <Navbar.Brand href="/">CMS Soniteka</Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto"></Nav>
                        <Nav>
                            <Nav.Link href="/">Igre</Nav.Link>
                            <Nav.Link href="/preview-order">Narudžbe</Nav.Link>
                            <Nav.Link href="/preview-faq">Faq</Nav.Link>
                            <Nav.Link href="/preview-category">Kategorije</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    )
}

export default Navigation
